/* Custom Size Dropdown */
function customSizeDropDownMeta(v) {
  jQuery('#customSizeMetaWrapper').html("")
  var htmlDiv = ''
  var fetchSelectedCaratWeight = (getParameterByName("size") && getParameterByName("size") != null) ? getParameterByName("size") : getCaratWeightSelectedOption
  if (getCustomSizeSelectedOption && getCustomSizeSelectedOption != ''){
    fetchSelectedCaratWeight = getCustomSizeSelectedOption
  }
  var grabDropDownName = currentProductJson.tags.filter(s => s.includes('add_style_type'));
  var grabSterlingDropDownName = currentProductJson.tags.filter(s => s.includes('sterling_type_option'));
  var hideDiamondShapeDropdown = currentProductJson.tags.filter(s => s.includes('hide_diamond_shape_option'));
  var everywhereHoopsDropdown = currentProductJson.tags.filter(s => s.includes('everywhere-hoops-dropdown'));
  var diamondCoverageDropdown = currentProductJson.tags.filter(s => s.includes('show-diamond-coverage'));
  var coverageDropdown = currentProductJson.tags.filter(s => s.includes('show-coverage'));
  var birthstoneDropdown = currentProductJson.tags.filter(s => s.includes('show-birthstone-dropdown'));
  var widthDropdown = currentProductJson.tags.filter(s => s.includes('show-width-dropdown'));
  var letterDiamondCoverage = currentProductJson.tags.filter(s => s.includes('show-letter-diamond-coverage-options'));
  var checkDiamondTypeOptions = currentProductJson.tags.filter(s => s.includes('show-diamond-type-buttons'));
  var showDiamondTypeBtns = false;

  if(checkDiamondTypeOptions && checkDiamondTypeOptions.length) {
    showDiamondTypeBtns = true
  }
  
  var productProperty = "Size";
  if (grabDropDownName && grabDropDownName.length) {
    grabDropDownName = "Style";
    productProperty = "Style";
  } else if(grabSterlingDropDownName && grabSterlingDropDownName.length){
    grabDropDownName = "Shape";
    productProperty = "Shape";
  } else if(hideDiamondShapeDropdown && hideDiamondShapeDropdown.length){
    grabDropDownName = "Diamond Shape";
    productProperty = "Diamond Shape";
  } else if(everywhereHoopsDropdown && everywhereHoopsDropdown.length){
    grabDropDownName = "Width";
    productProperty = "Width";
  } else if(birthstoneDropdown && birthstoneDropdown.length){
    grabDropDownName = "Birthstone";
    productProperty = "Birthstone";
  } else if(diamondCoverageDropdown && diamondCoverageDropdown.length){
    grabDropDownName = "Diamond Coverage";
    productProperty = "Diamond Coverage";
  } else if(coverageDropdown && coverageDropdown.length){
    grabDropDownName = "Coverage";
    productProperty = "Coverage";
  } else if(widthDropdown && widthDropdown.length){
    grabDropDownName = "Width";
    productProperty = "Width";
  } else if(letterDiamondCoverage && letterDiamondCoverage.length){
    grabDropDownName = "Letter Diamond Coverage";
    productProperty = "Letter Diamond Coverage";
  } else {
    grabDropDownName = "Size";
  }

  var prefix = "Dropdown 1: "
  var filteredTags = currentProductJson.tags.filter(tag => tag.startsWith(prefix));
  var textAfterPrefix = filteredTags.map(tag => tag.slice(prefix.length));
  textAfterPrefix = textAfterPrefix[0];

  var hidePrefix = "Hide: "
  var filteredHideTags = currentProductJson.tags.filter(tag => tag.startsWith(hidePrefix));
  var textAfterHidePrefix = filteredHideTags?.map(tag => tag.slice(hidePrefix.length));

  if (textAfterHidePrefix?.some(prefix => textAfterPrefix?.includes(prefix))) return;
  
  if (textAfterPrefix && textAfterPrefix.length) {
    grabDropDownName = textAfterPrefix;
    productProperty = textAfterPrefix;
  }
  if (v && fetchSelectedCaratWeight.toLowerCase() !== 'natural diamonds' && fetchSelectedCaratWeight.toLowerCase() !== 'lab grown diamonds') {
    htmlDiv += `<div class="ProductForm__Option custom-size-dropdown ${grabDropDownName}">`;
    htmlDiv += `<span class="dropdown-lable dropdown-lable-style">`+ grabDropDownName +`:</span>`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-custom-size-dropdown-options" type="button" class="ProductForm__Item custom_size_meta_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-custom-size-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="ProductForm__SelectedValuSizeMeta` + v.id + ` dropdown-selected-value">` + fetchSelectedCaratWeight + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-custom-size-dropdown-options" class="OptionSelector custom_size_meta_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">`+ grabDropDownName +`</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList custom-size-dropdown" data-scrollable="">`;
    getSizeOptions = JSON.parse(getSizeOptions)
    if (getSizeOptions && getSizeOptions?.length != 0) {
      for (var j = 0; j < getSizeOptions.length; j++) {
        var variant = getSizeOptions[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        htmlDiv += `<a class="hide-underline" href="` + redirectProductUrl + `"><button type="button" class="custom_size_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" font-family="` + variant.font + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `"` + (variant.font ? ` style="font-family: ` + variant.font + `;"` : ``) + `>`;
        htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
        htmlDiv += `</button></a>`;
      }
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".Total.Carat.Weight.ProductForm__Option").length !== 0) {
      $(".Total.Carat.Weight.ProductForm__Option").after(htmlDiv)
    } else if ($(".Metal.ProductForm__Option").length !== 0 && textAfterPrefix === "Diamond Type") {
      $(".Metal.ProductForm__Option").before(htmlDiv)
    } else if($(".Carats.ProductForm__Option").length !== 0){
      $(".Carats.ProductForm__Option").after(htmlDiv)
    } else if($(".Carat.ProductForm__Option").length !== 0){
      $(".Carat.ProductForm__Option").after(htmlDiv)
    } else if($(".ProductForm__Option.carat-weight-dropdown").length !== 0){
      $(".ProductForm__Option.carat-weight-dropdown").after(htmlDiv)
    } else if($(".Width.ProductForm__Option").length !== 0 ){
      $(".Width.ProductForm__Option").after(htmlDiv)
    } else if ($(".Metal.ProductForm__Option").length !== 0 && textAfterPrefix !== "Diamond Type") {
      $(".Metal.ProductForm__Option").after(htmlDiv)
    } else {
      $('#customSizeMetaWrapper').append(htmlDiv)
    }
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionCustomSizeDropdown()
    stopScreenFreeze()
  } else if (v && showDiamondTypeBtns === true && (fetchSelectedCaratWeight.toLowerCase() === 'natural diamonds' || fetchSelectedCaratWeight.toLowerCase() === 'lab grown diamonds')){
    getSizeOptions = JSON.parse(getSizeOptions)
    htmlDiv += `<span class="ProductForm__Label ">Diamond Type: </span>`;  
    htmlDiv += `<div class="type-buttons" id="appendDiamondTypeButtons">`;
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    if (getSizeOptions && getSizeOptions?.length != 0) {
      for (var j = 0; j < getSizeOptions.length; j++) {
        var variant = getSizeOptions[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        if (fetchSelectedCaratWeight === variant.title) {
          htmlDiv += `<button type="button" class="type-btn selected-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        } else {
          htmlDiv += `<button type="button" class="type-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        }
      }
    }
    htmlDiv += `</div>`
    $('#customSizeMetaWrapper').append(htmlDiv)
  } else {
    console.log("option2 is not a number")
  }
}

/* Custom Size Dropdown: Second Dropdown */
function customSizeDropDownMeta_2(v) {
  jQuery('#customSizeMetaWrapper_2').html("")
  var htmlDiv = ''
  var fetchSelectedCaratWeight = (getParameterByName("size") && getParameterByName("size") != null) ? getParameterByName("size") : getCustomSizeSelectedOption_2
  if (getCustomSizeSelectedOption_2 && getCustomSizeSelectedOption_2 != ''){
    fetchSelectedCaratWeight = getCustomSizeSelectedOption_2
  }
  var checkDiamondTypeOptions = currentProductJson.tags.filter(s => s.includes('show-diamond-type-buttons'));
  var showDiamondTypeBtns = false;

  if(checkDiamondTypeOptions && checkDiamondTypeOptions.length) {
    showDiamondTypeBtns = true
  }

  var prefix = "Dropdown 2: "
  var filteredTags = currentProductJson.tags.filter(tag => tag.startsWith(prefix));
  var textAfterPrefix = filteredTags.map(tag => tag.slice(prefix.length));
  textAfterPrefix = textAfterPrefix[0];

  var hidePrefix = "Hide: "
  var filteredHideTags = currentProductJson.tags.filter(tag => tag.startsWith(hidePrefix));
  var textAfterHidePrefix = filteredHideTags?.map(tag => tag.slice(hidePrefix.length));

  if (textAfterHidePrefix?.some(prefix => textAfterPrefix?.includes(prefix))) return;
  
  var productProperty = "Width";
  var grabDropDownName = "Width";
  if (textAfterPrefix && textAfterPrefix.length) {
    grabDropDownName = textAfterPrefix;
    productProperty = textAfterPrefix;
  }
  
  if (v && fetchSelectedCaratWeight.toLowerCase() !== 'natural diamonds' && fetchSelectedCaratWeight.toLowerCase() !== 'lab grown diamonds') {
    htmlDiv += `<div class="ProductForm__Option custom-size-dropdown ${grabDropDownName}">`;
    htmlDiv += `<span class="dropdown-lable dropdown-lable-style">`+ grabDropDownName +`:</span>`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-custom-size-dropdown-options_2" type="button" class="ProductForm__Item custom_size_meta_drop_down_2" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-custom-size-dropdown-options_2">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="ProductForm__SelectedValuSizeMeta` + v.id + ` dropdown-selected-value">` + getCustomSizeSelectedOption_2 + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-custom-size-dropdown-options_2" class="OptionSelector custom_size_meta_dropdown_popover_2 Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">`+ grabDropDownName +`</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList custom-size-dropdown" data-scrollable="">`;
    getSizeOptions_2 = JSON.parse(getSizeOptions_2)
    if (getSizeOptions_2 && getSizeOptions_2?.length != 0) {
      for (var j = 0; j < getSizeOptions_2.length; j++) {
        var variant = getSizeOptions_2[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        htmlDiv += `<a class="hide-underline" href="` + redirectProductUrl + `"><button type="button" class="custom_size_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `"` + (variant.font ? ` style="font-family: ` + variant.font + `;"` : ``) + `>`;
        htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
        htmlDiv += `</button></a>`;
      }
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".Metal.ProductForm__Option").length !== 0 && $(".Carat.Weight.Per.Stone.ProductForm__Option ").length === 0 && textAfterPrefix !== "Diamond Type" && textAfterPrefix !== "Diamond Coverage" && textAfterPrefix !== "Diamond Shape") {
      $(".Metal.ProductForm__Option").after(htmlDiv)
    } else if($(".ProductForm__Option.custom-size-dropdown.Diamond.Shape").length !== 0 && textAfterPrefix === "Diamond Coverage"){
      $(".ProductForm__Option.custom-size-dropdown.Diamond.Shape").before(htmlDiv)
    } else if ($(".Metal.ProductForm__Option").length !== 0 && textAfterPrefix === "Diamond Type") {
      $(".Metal.ProductForm__Option").before(htmlDiv)
    } else if ($(".Carat.Weight.ProductForm__Option").length !== 0) {
      $(".Carat.Weight.ProductForm__Option").after(htmlDiv)
    } else if ($(".ProductForm__Option.custom-size-dropdown").length !== 0) {
      $(".ProductForm__Option.custom-size-dropdown").after(htmlDiv)
    } else if ($(".Carat.Weight.Per.Stone.ProductForm__Option ").length !== 0) {
      $(".Carat.Weight.Per.Stone.ProductForm__Option").after(htmlDiv)
    } else if($(".Size.ProductForm__Option.ProductForm__Option--labelled").length !== 0 && textAfterPrefix === "Diamond Coverage"){
      $(".Size.ProductForm__Option.ProductForm__Option--labelled").before(htmlDiv)
    } else {
      $('#customSizeMetaWrapper_2').append(htmlDiv)
    }
    
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionCustomSizeDropdown_2()
    stopScreenFreeze()
  } else if (v && showDiamondTypeBtns === true && (fetchSelectedCaratWeight.toLowerCase() === 'natural diamonds' || fetchSelectedCaratWeight.toLowerCase() === 'lab grown diamonds')){
    getSizeOptions_2 = JSON.parse(getSizeOptions_2)
    htmlDiv += `<span class="ProductForm__Label ">Diamond Type: </span>`;  
    htmlDiv += `<div class="type-buttons" id="appendDiamondTypeButtons">`;
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    if (getSizeOptions_2 && getSizeOptions_2?.length != 0) {
      for (var j = 0; j < getSizeOptions_2.length; j++) {
        var variant = getSizeOptions_2[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        if (fetchSelectedCaratWeight === variant.title) {
          htmlDiv += `<button type="button" class="type-btn selected-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        } else {
          htmlDiv += `<button type="button" class="type-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        }
      }
    }
    htmlDiv += `</div>`
    $('#customSizeMetaWrapper').append(htmlDiv)
  } else {
    console.log("option2 is not a number")
  }
}

/* Custom Size Dropdown: Third Dropdown */
function customSizeDropDownMeta_3(v) {
  jQuery('#customSizeMetaWrapper_3').html("")
  var htmlDiv = ''
  var fetchSelectedCaratWeight = (getParameterByName("size") && getParameterByName("size") != null) ? getParameterByName("size") : getCaratWeightSelectedOption
  if (getCustomSizeSelectedOption_3 && getCustomSizeSelectedOption_3 != ''){
    fetchSelectedCaratWeight = getCustomSizeSelectedOption_3
  }

  var checkDiamondTypeOptions = currentProductJson.tags.filter(s => s.includes('show-diamond-type-buttons'));
  var showDiamondTypeBtns = false;

  if(checkDiamondTypeOptions && checkDiamondTypeOptions.length) {
    showDiamondTypeBtns = true
  }

  var prefix = "Dropdown 3: "
  var filteredTags = currentProductJson.tags.filter(tag => tag.startsWith(prefix));
  var textAfterPrefix = filteredTags.map(tag => tag.slice(prefix.length));
  textAfterPrefix = textAfterPrefix[0];

  var hidePrefix = "Hide: "
  var filteredHideTags = currentProductJson.tags.filter(tag => tag.startsWith(hidePrefix));
  var textAfterHidePrefix = filteredHideTags?.map(tag => tag.slice(hidePrefix.length));

  if (textAfterHidePrefix?.some(prefix => textAfterPrefix?.includes(prefix))) return;
  
  var productProperty = "Width";
  var grabDropDownName = "Width";
  if (textAfterPrefix && textAfterPrefix.length) {
    grabDropDownName = textAfterPrefix;
    productProperty = textAfterPrefix;
  }
  
  if (v && fetchSelectedCaratWeight.toLowerCase() !== 'natural diamonds' && fetchSelectedCaratWeight.toLowerCase() !== 'lab grown diamonds') {
    htmlDiv += `<div class="ProductForm__Option custom-size-dropdown ${grabDropDownName}">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-custom-size-dropdown-options_3" type="button" class="ProductForm__Item custom_size_meta_drop_down_3" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-custom-size-dropdown-options_3">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">`+ grabDropDownName +`</span><span class="ProductForm__SelectedValuSizeMeta` + v.id + ` dropdown-selected-value">` + getCustomSizeSelectedOption_3 + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-custom-size-dropdown-options_3" class="OptionSelector custom_size_meta_dropdown_popover_3 Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">`+ grabDropDownName +`:</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList custom-size-dropdown" data-scrollable="">`;
    getSizeOptions_3 = JSON.parse(getSizeOptions_3)
    if (getSizeOptions_3 && getSizeOptions_3?.length != 0) {
      for (var j = 0; j < getSizeOptions_3.length; j++) {
        var variant = getSizeOptions_3[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        htmlDiv += `<a class="hide-underline" href="` + redirectProductUrl + `"><button type="button" class="custom_size_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `"` + (variant.font ? ` style="font-family: ` + variant.font + `;"` : ``) + `>`;
        htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
        htmlDiv += `</button></a>`;
      }
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".Metal.ProductForm__Option").length !== 0 && $(".Carat.Weight.Per.Stone.ProductForm__Option ").length === 0 && textAfterPrefix !== "Diamond Type" && textAfterPrefix !== "Diamond Coverage" && textAfterPrefix !== "Diamond Shape") {
      $(".Metal.ProductForm__Option").after(htmlDiv)
    } else if($(".ProductForm__Option.custom-size-dropdown.Diamond.Shape").length !== 0 && textAfterPrefix === "Diamond Coverage"){
      $(".ProductForm__Option.custom-size-dropdown.Diamond.Shape").before(htmlDiv)
    } else if ($(".Metal.ProductForm__Option").length !== 0 && textAfterPrefix === "Diamond Type") {
      $(".Metal.ProductForm__Option").before(htmlDiv)
    } else if ($(".Carat.Weight.ProductForm__Option").length !== 0) {
      $(".Carat.Weight.ProductForm__Option").after(htmlDiv)
    } else if ($(".ProductForm__Option.custom-size-dropdown").length !== 0) {
      $(".ProductForm__Option.custom-size-dropdown").after(htmlDiv)
    } else if ($(".Carat.Weight.Per.Stone.ProductForm__Option ").length !== 0) {
      $(".Carat.Weight.Per.Stone.ProductForm__Option").after(htmlDiv)
    } else {
      $('#customSizeMetaWrapper_3').append(htmlDiv)
    }
    
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionCustomSizeDropdown_3()
    stopScreenFreeze()
  } else if (v && showDiamondTypeBtns === true && (fetchSelectedCaratWeight.toLowerCase() === 'natural diamonds' || fetchSelectedCaratWeight.toLowerCase() === 'lab grown diamonds')){
    getSizeOptions_3 = JSON.parse(getSizeOptions_3)
    htmlDiv += `<span class="ProductForm__Label ">Diamond Type: </span>`;  
    htmlDiv += `<div class="type-buttons" id="appendDiamondTypeButtons">`;
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    if (getSizeOptions_3 && getSizeOptions_3?.length != 0) {
      for (var j = 0; j < getSizeOptions_3.length; j++) {
        var variant = getSizeOptions_3[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        if (fetchSelectedCaratWeight === variant.title) {
          htmlDiv += `<button type="button" class="type-btn selected-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        } else {
          htmlDiv += `<button type="button" class="type-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        }
      }
    }
    htmlDiv += `</div>`
    $('#customSizeMetaWrapper').append(htmlDiv)
  } else {
    console.log("option2 is not a number")
  }
}

/* Custom Size Dropdown: Fourth Dropdown */
function customSizeDropDownMeta_4(v) {
  jQuery('#customSizeMetaWrapper_4').html("")
  var htmlDiv = ''
  var fetchSelectedCaratWeight = (getParameterByName("size") && getParameterByName("size") != null) ? getParameterByName("size") : getCaratWeightSelectedOption
  if (getCustomSizeSelectedOption_4 && getCustomSizeSelectedOption_4 != ''){
    fetchSelectedCaratWeight = getCustomSizeSelectedOption_4
  }

  var checkDiamondTypeOptions = currentProductJson.tags.filter(s => s.includes('show-diamond-type-buttons'));
  var showDiamondTypeBtns = false;

  if(checkDiamondTypeOptions && checkDiamondTypeOptions.length) {
    showDiamondTypeBtns = true
  }

  var prefix = "Dropdown 4: "
  var filteredTags = currentProductJson.tags.filter(tag => tag.startsWith(prefix));
  var textAfterPrefix = filteredTags.map(tag => tag.slice(prefix.length));
  textAfterPrefix = textAfterPrefix[0];

  var hidePrefix = "Hide: "
  var filteredHideTags = currentProductJson.tags.filter(tag => tag.startsWith(hidePrefix));
  var textAfterHidePrefix = filteredHideTags?.map(tag => tag.slice(hidePrefix.length));

  if (textAfterHidePrefix?.some(prefix => textAfterPrefix?.includes(prefix))) return;
  
  var productProperty = "Width";
  var grabDropDownName = "Width";
  if (textAfterPrefix && textAfterPrefix.length) {
    grabDropDownName = textAfterPrefix;
    productProperty = textAfterPrefix;
  }
  
  if (v && fetchSelectedCaratWeight.toLowerCase() !== 'natural diamonds' && fetchSelectedCaratWeight.toLowerCase() !== 'lab grown diamonds') {
    htmlDiv += `<div class="ProductForm__Option custom-size-dropdown ${grabDropDownName}">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-custom-size-dropdown-options_4" type="button" class="ProductForm__Item custom_size_meta_drop_down_4" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-custom-size-dropdown-options_4">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">`+ grabDropDownName +`</span><span class="ProductForm__SelectedValuSizeMeta` + v.id + ` dropdown-selected-value">` + getCustomSizeSelectedOption_4 + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-custom-size-dropdown-options_4" class="OptionSelector custom_size_meta_dropdown_popover_4 Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">`+ grabDropDownName +`:</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList custom-size-dropdown" data-scrollable="">`;
    getSizeOptions_4 = JSON.parse(getSizeOptions_4)
    if (getSizeOptions_4 && getSizeOptions_4?.length != 0) {
      for (var j = 0; j < getSizeOptions_4.length; j++) {
        var variant = getSizeOptions_4[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        htmlDiv += `<a class="hide-underline" href="` + redirectProductUrl + `"><button type="button" class="custom_size_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `"` + (variant.font ? ` style="font-family: ` + variant.font + `;"` : ``) + `>`;
        htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
        htmlDiv += `</button></a>`;
      }
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;
    
    if ($(".Metal.ProductForm__Option").length !== 0 && $(".Carat.Weight.Per.Stone.ProductForm__Option ").length === 0 && textAfterPrefix !== "Diamond Type" && textAfterPrefix !== "Diamond Coverage" && textAfterPrefix !== "Diamond Shape" && textAfterPrefix !== "Birthstone") {
      $(".Metal.ProductForm__Option").after(htmlDiv)
    } else if($(".ProductForm__Option.custom-size-dropdown.Diamond.Shape").length !== 0 && textAfterPrefix === "Diamond Coverage"){
      $(".ProductForm__Option.custom-size-dropdown.Diamond.Shape").before(htmlDiv)
    } else if ($(".Size.ProductForm__Option").length !== 0 && textAfterPrefix === "Birthstone") {
      $(".Size.ProductForm__Option").before(htmlDiv)
    } else if ($(".Metal.ProductForm__Option").length !== 0 && textAfterPrefix === "Diamond Type") {
      $(".Metal.ProductForm__Option").before(htmlDiv)
    } else if ($(".Carat.Weight.ProductForm__Option").length !== 0) {
      $(".Carat.Weight.ProductForm__Option").after(htmlDiv)
    } else if ($(".ProductForm__Option.custom-size-dropdown").length !== 0) {
      $(".ProductForm__Option.custom-size-dropdown").after(htmlDiv)
    } else if ($(".Carat.Weight.Per.Stone.ProductForm__Option ").length !== 0) {
      $(".Carat.Weight.Per.Stone.ProductForm__Option").after(htmlDiv)
    } else {
      $('#customSizeMetaWrapper_4').append(htmlDiv)
    }
    
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionCustomSizeDropdown_4()
    stopScreenFreeze()
  } else if (v && showDiamondTypeBtns === true && (fetchSelectedCaratWeight.toLowerCase() === 'natural diamonds' || fetchSelectedCaratWeight.toLowerCase() === 'lab grown diamonds')){
    getSizeOptions_4 = JSON.parse(getSizeOptions_4)
    htmlDiv += `<span class="ProductForm__Label ">Diamond Type: </span>`;  
    htmlDiv += `<div class="type-buttons" id="appendDiamondTypeButtons">`;
    htmlDiv += `<input type="hidden" name="properties[`+ productProperty +`]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    if (getSizeOptions_4 && getSizeOptions_4?.length != 0) {
      for (var j = 0; j < getSizeOptions_3.length; j++) {
        var variant = getSizeOptions_4[j];
        var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + grabDropDownName + '=' + variant.title : variant.url + '?' + grabDropDownName + '=' + variant.title;
        if (fetchSelectedCaratWeight === variant.title) {
          htmlDiv += `<button type="button" class="type-btn selected-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        } else {
          htmlDiv += `<button type="button" class="type-btn" onclick="window.location='${redirectProductUrl}'"> ${variant.title} </button>`;
        }
      }
    }
    htmlDiv += `</div>`
    $('#customSizeMetaWrapper').append(htmlDiv)
  } else {
    console.log("option2 is not a number")
  }
}

var fontOptions = [];
function fontOptionsDropdownArray() {
  for (var i = 0; i < currentProductJson.tags.length; i++) {
    if (currentProductJson.tags[i].indexOf('Font-') > -1) {
      fontOptions.push(currentProductJson.tags[i].replace("Font-", ""))
    }
  }
}

function fontDropDown(v){
  jQuery('#fontWrapper').html("");
  var htmlDiv = ''
  if (v) {
    htmlDiv += `<div class="ProductForm__Option font-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-font-dropdown-options" type="button" class="ProductForm__Item font_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-font-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Font: </span><span class="ProductForm__SelectedValueFont` + v.id + ` dropdown-selected-value">Select</span></span>`
    htmlDiv += `<input type="hidden" id="fontName" name="properties[Font]" class="font_option_value` + v.id + `_selectedvalue" value=''>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-font-dropdown-options" class="OptionSelector font_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Font:</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList font-dropdown" data-scrollable="">`;
    for (var j = 0; j < fontOptions.length; j++) {
      var variant = fontOptions[j];
      var textTransform = "";
      if (variant === "Bernhard Tango") {
        fontFamily = "BernhardTangoBT"
      } else if (variant === "Celine") {
        fontFamily = "BV Celine";
        textTransform = "uppercase";
      } else if (variant === "Seagram") {
        fontFamily = "Seagramtfb";
      } else {
        fontFamily = variant.replace(/\s/g, "");
      }
      htmlDiv += `<button type="button" class="font_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant + `" data-value="` + variant + `"  style="font-family:` + fontFamily + `; text-transform:` + textTransform + `">`;
      htmlDiv += `<span class="dropdown-title">` + variant + `</span>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    jQuery('#fontWrapper').append(htmlDiv)
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionFont()
    stopScreenFreeze()
    /* Show Engraving Toggle */
    // $('#engravablesInputsWrapperSlider').removeClass('hide')
  } else {
    console.log("option2 is not a number")
  }
}

/* Metal Color dropdown */
function metalColorDropDown(v) {
  jQuery('#metal-color-dropdown').html("")
  var htmlDiv = ''
  var fetchSelectedCaratWeight = (getParameterByName("size") && getParameterByName("size") != null) ? getParameterByName("size") : getCaratWeightSelectedOption
  if (getMetalSelectedOption && getMetalSelectedOption != ''){
    fetchSelectedCaratWeight = getMetalSelectedOption
  }
  
  var prefix = "Dropdown Metal: "
  var filteredTags = currentProductJson.tags.filter(tag => tag.startsWith(prefix));
  var textAfterPrefix = filteredTags.map(tag => tag.slice(prefix.length));
  textAfterPrefix = textAfterPrefix[0];

  var hidePrefix = "Hide: "
  var filteredHideTags = currentProductJson.tags.filter(tag => tag.startsWith(hidePrefix));
  var textAfterHidePrefix = filteredHideTags.map(tag => tag.slice(hidePrefix.length));

  if (textAfterHidePrefix.some(prefix => textAfterPrefix.includes(prefix)) || textAfterHidePrefix === textAfterPrefix) return;
  
  if (v) {
    htmlDiv += `<span class="Product-Form__Label">${textAfterPrefix}: <span class="ProductForm__SelectedValue">${fetchSelectedCaratWeight}</span></span>`;
    htmlDiv += `<ul class="color-dropdown-list">`
    var metalOptions = JSON.parse(getMetalOptions)
    for (let k = 0; k < metalOptions.length; k++) {
      var variant = metalOptions[k];
      var imageURL = getImageURLByTitle(variant.title);     
      var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&' + textAfterPrefix + '=' + variant.title : variant.url + '?' + textAfterPrefix + '=' + variant.title;
      htmlDiv += `<li class="HorizontalList__Item" oldId="` + v.id + `" image-url="` + imageURL + `" index="` + k + `" data-price="` + variant.price + `" data-title="` + fetchSelectedCaratWeight + `" data-value="` + variant.id + `" onclick="location.href='${redirectProductUrl}'">`;
      htmlDiv += `<input id="option-product-template-0-` + k + `" class="ColorCircle__Radio" type="radio" name="option-0" value="${fetchSelectedCaratWeight}" checked="checked" data-option-position="1" autofilled="">`;
      htmlDiv += `<label for="option-product-template-0-` + k + `" class="Color-circle ` + (fetchSelectedCaratWeight === variant.title ? 'is-active' : '') + `" data-tooltip="${variant.title}" style="background-color: silver; background-image: url(${imageURL})"><span class="u-visually-hidden">${fetchSelectedCaratWeight}</span></label>`;
      htmlDiv += `</li>`;
    }
    htmlDiv += `<input type="hidden" name="properties[Metal]" class="color_dropdown_title` + v.id + `_selectedvalue" value='` + fetchSelectedCaratWeight + `'>`;
    htmlDiv += `</ul>`
    
    jQuery('#metal-color-dropdown').append(htmlDiv)
    /* Enabling Add to cart button */
    enableAddToCartButton()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

function setClickActionFont() {
  jQuery(".font_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        if (pos.top > 650) {
          tops = pos.top + 20 - scrollHeight
        } else {
          tops = pos.top - 120 - scrollHeight
        }
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}

/* Set Click Actions */
function setClickActionCustomSizeDropdown() {
  jQuery(".custom_size_meta_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 10 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}

function setClickActionCustomSizeDropdown_2() {
  jQuery(".custom_size_meta_drop_down_2").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 10 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}

function setClickActionCustomSizeDropdown_3() {
  jQuery(".custom_size_meta_drop_down_3").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 10 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}

function setClickActionCustomSizeDropdown_4() {
  jQuery(".custom_size_meta_drop_down_4").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 10 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}
